import { StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { BaseStore } from '../base/base.store';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'resource' })
export class ResourceStore extends BaseStore {
  constructor() {
    super();
  }
}
